import { useEffect } from "react";

import { default as PlaceAutoComplete, resolveCategory } from "../../../third_parties/map/placeAutoComplete";
import Button from "@mui/material/Button";
import { APIProvider, Map, Marker, useApiIsLoaded } from "@vis.gl/react-google-maps";
import { Box, Tooltip } from "@mui/material";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const FindPlaceContent = ({ spotReview, setSpotReview, placeName, setPlaceName, setPlaceAddress, geo, setGeo, handleNext }) => {
    const isLoaded = useApiIsLoaded();

    useEffect(() => {
        if (placeName === "") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setGeo({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        })
                    },
                    (error) => {
                        console.error('Error getting location:', error);
                    }
                );
            } else {
                console.error('Geolocation is not supported by this browser.');
            }
        }
    }, [placeName, setGeo]);

    const handleTypesResolved = (types) => {
        const category = resolveCategory(types);
        setSpotReview((prev) => ({
            ...prev,
            placeTypes: types,
            category,
        }));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1, width: '100%', flex: 1 }}>
            <Box>
                <Box component="h3" sx={{ m: 0, fontSize: '1.25rem', fontWeight: 600, color: 'text.primary' }}>
                    Find the place
                </Box>
                <Box sx={{ fontSize: '0.85rem', color: 'text.secondary', mt: 0.5 }}>
                    Search for a location to review.
                </Box>
            </Box>
            <PlaceAutoComplete
                label="place"
                name="place"
                dataModel={spotReview}
                setDataModel={setSpotReview}
                placeName={placeName}
                setPlaceName={setPlaceName}
                setPlaceAddress={setPlaceAddress}
                geo={geo}
                setGeo={setGeo}
                isLoaded={isLoaded}
                onTypesResolved={handleTypesResolved}
            />
            <Box sx={{ height: { xs: 200, sm: 280 }, width: '100%', borderRadius: 1, overflow: 'hidden' }}>
                <Map
                    defaultZoom={13}
                    defaultCenter={geo}
                    center={geo}
                    style={{ width: '100%', height: '100%' }}
                >
                    {placeName ? <Marker position={geo} /> : <></>}
                </Map>
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
                {spotReview.placeId === null || spotReview.placeId === '' ?
                    <Tooltip title="Choose a place to continue">
                        <span>
                            <Button
                                disabled
                                variant="contained"
                                sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}
                            >
                                Next
                            </Button>
                        </span>
                    </Tooltip> :
                    <Button
                        onClick={handleNext}
                        variant="contained"
                        color="primary"
                        sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}
                    >
                        Next
                    </Button>}
            </Box>
        </Box>
    );
};

const FindPlaceCreationStep = (props) => {
    return (
        <APIProvider apiKey={API_KEY} version="weekly">
            <FindPlaceContent {...props} />
        </APIProvider>
    );
};

export default FindPlaceCreationStep;
